// extracted by mini-css-extract-plugin
module.exports =  {"layout":"e2ff468f85--layout--dVaQU","spinner":"e2ff468f85--spinner--e_O7D","container":"e2ff468f85--container--M0xiL","error":"e2ff468f85--error--AcAkz"};